import React from "react";
import { choiceHeaderStyles as styles } from "./styles";
import { TouchableOpacity } from "../Buttons";
import { Text } from "../Text";
import ExpandIcon from "./ExpandIcon";

type ChoiceHeaderProps = {
  isOpen?: boolean;
  onHeaderPress: () => void;
  header: string | undefined;
};

const ChoiceHeader = ({
  isOpen = false,
  onHeaderPress,
  header,
}: ChoiceHeaderProps): JSX.Element => {
  return (
    <TouchableOpacity onPress={onHeaderPress} style={styles.container}>
      <Text style={styles.headerText}>{header}</Text>
      <ExpandIcon isOpen={!!isOpen} />
    </TouchableOpacity>
  );
};

export default ChoiceHeader;
